import React from 'react';
import { Modal } from '@quyva/shared-ui';
import { faClipboardList } from '@fortawesome/free-solid-svg-icons';
import FormRenderer from '../formInput/FormRenderer';

/**
 * Renders the form a suspended agent task is waiting on, so the user can fill it in from
 * their task tab. Submitting resumes the agent with the collected answers.
 *
 * Used by the Tasks page (`components/tasks/TasksPage.jsx`), not by the agent-logs view it sits
 * next to: a 'user_input' suspension is waiting on the person who started the run, and they are
 * the only one who can answer it.
 *
 * The form's Cancel button and the modal's close (X) are deliberately DIFFERENT actions:
 * Cancel ends the task, while closing just dismisses the dialog and leaves the task waiting
 * so it can be reopened. An accidental dismiss must not destroy a running task.
 *
 * @param {object} formConfig the required_input.input_json of the suspension
 * @param {string} taskLabel  query/agent name shown in the modal title
 * @param {(answers: Record<string, string>) => void} onSubmit
 * @param {() => void} onCancel  cancels the task (status becomes Cancelled)
 * @param {() => void} onClose   dismisses the dialog only; task stays Waiting
 */
const ResumeFormModal = ({
    formConfig,
    taskLabel,
    onSubmit,
    onCancel,
    onClose,
}) => (
    <Modal
        title={taskLabel ? `Fill in details for ${taskLabel}` : 'Fill in details'}
        titleIcon={faClipboardList}
        onClose={onClose}
        className='w-[46rem]'
        bodyClassName='w-full max-h-[80vh] bg-backgrounds-white overflow-auto'
    >
        <FormRenderer
            formConfig={formConfig}
            onSubmit={onSubmit}
            onCancel={onCancel}
            isPanel
        />
    </Modal>
);

export default ResumeFormModal;
